import ApiService from "@/common/api.service";
import moment from "moment"

const noData = [null, "", undefined, "null"]

const state = {
  commercialSchedules: [],
  loadingCommercialSchedules: false,
  selectedCommercialScheduleId: null,

  nextCommercialClenupDay: null,
  loadingNextCommercialClenupDay: false,
};

const getters = {
  commercialSchedules(state) {
    return state.commercialSchedules;
  },
  loadingCommercialSchedules(state) {
    return state.loadingCommercialSchedules;
  },
  selectedCommercialSchedule(state, getters) {
    if(
      !noData.includes(state.selectedCommercialScheduleId) &&
      getters.commercialSchedules.some(i => i.client_location_id === state.selectedCommercialScheduleId)
    ) {
      return getters.commercialSchedules.find(i => i.client_location_id === state.selectedCommercialScheduleId)
    }
    return null
  },

  commercialUnassigned (state, getters) {
    let out = getters.commercialSchedules.filter(s => {
      return !noData.includes(s.unasigned) && Boolean(Number(s.unasigned))
    })
    return out 
  },
  isCommercialUnassigned: state => data => {
    let res = data
    let recuring_service_days = res.service_days.filter(i => i.service_type === "recurring")
    let one_time_service_days = res.service_days.filter(i => i.service_type === "one_time")

    const unassigned = (
      recuring_service_days.length === 0 && 
      !noData.includes(res.clean_up_frequency) && 
      res.clean_up_frequency !== 'one_time'
    ) ||
    (
      one_time_service_days.length === 0 &&
      (
        noData.includes(res.clean_up_frequency) ||
        res.clean_up_frequency === 'one_time'
      )
    )
    return unassigned
  },

  jobDatesForCommercial (state, getters) {
    return getters.selectedCommercialSchedule ? 
          getters.selectedCommercialSchedule :
          null
  },
  nextCommercialClenupDay (state, getters) {
    return getters.selectedCommercialSchedule &&
          getters.selectedCommercialSchedule.status === 'active' &&
          getters.selectedCommercialSchedule.nextCleanup ? 
          getters.selectedCommercialSchedule.nextCleanup :
          null
  },
  loadingNextCommercialClenupDay(state) {
    return state.loadingNextCommercialClenupDay;
  },
  showNextCommercialCleanupDayNote (state, getters) {
    return getters.nextCommercialClenupDay &&
      getters.nextCommercialClenupDay.next_cleanup &&
      getters.selectedCommercialSchedule.subscription &&
      getters.selectedCommercialSchedule.subscription.pause_subscription_start_date &&
      getters.selectedCommercialSchedule.subscription.pause_subscription_end_date &&
      moment(getters.nextCommercialClenupDay.next_cleanup, "MMM D[,]YYYY").isBetween(
        moment(getters.selectedCommercialSchedule.subscription.pause_subscription_start_date),
        moment(getters.selectedCommercialSchedule.subscription.pause_subscription_end_date),
        undefined,
        '[)'
      )
  },
  commercialSubscriptionPauseStartDate (state, getters) {
    if (
      getters.selectedCommercialSchedule &&
      getters.selectedCommercialSchedule.subscription &&
      getters.selectedCommercialSchedule.subscription.pause_subscription_start_date
    ) {
      return getters.selectedCommercialSchedule.subscription.pause_subscription_start_date
    } else {
      return null
    }
  },
  commercialSubscriptionPauseEndDate (state, getters) {
    if (
      getters.selectedCommercialSchedule &&
      getters.selectedCommercialSchedule.subscription &&
      getters.selectedCommercialSchedule.subscription.pause_subscription_end_date
    ) {
      return getters.selectedCommercialSchedule.subscription.pause_subscription_end_date
    } else {
      return null
    }
  }
}

const actions = {
  getCommercialSchedules (context, payload) {
    context.commit('setLoadingCommercialSchedules', true);
    context.commit('setCommercialSchedules', [])
    return new Promise((resolve, reject) => {
      let body = {
        commercial_location_id: context.getters.loadedLocation.id,
        organization_id: context.getters.organizationId,
        ...payload
      }
      ApiService.get("/commercial/client_locations_for_commercial_client", body)
        .then(response => {
          let schedules = response.data.client_locations
          context.commit('setCommercialSchedules', schedules);
          context.commit('setLoadingCommercialSchedules', false);
          if(
            context.getters.commercialSchedules &&
            context.getters.commercialSchedules.length &&
            noData.includes(context.getters.selectedCommercialSchedule)
          ) {
            context.commit('setSelectedCommercialSchedule', context.getters.commercialSchedules[0])
          }
          resolve(schedules);
        })
        .catch(({response}) => {
          console.log('Commercial Schedules Error');
          context.commit('setLoadingCommercialSchedules', false);
          reject(response);
        })
    })
  },
  getNextCommercialClenupDay(context, body) {
    context.commit('setLoadingNextCommercialClenupDay', true);
    context.commit('setNextCommercialClenupDay', null)
    context.dispatch('getCommercialSubscription')
    return new Promise((resolve, reject) => {
      ApiService.get("/next_cleanup_day", body)
        .then(response => {
          context.commit('setNextCommercialClenupDay', {
            client_location_id: body.client_location_id,
            next_cleanup: response.data.next_cleanup
          });
          context.commit('setLoadingNextCommercialClenupDay', false);
          resolve(response);
        })
        .catch(({response}) => {
          console.log('Next Cleanup Day Error');
          context.commit('setLoadingNextCommercialClenupDay', false);
          reject(response);
        })
    })
  },
  getCommercialSubscription(context, body) {
    return new Promise((resolve, reject) => {
      if (
        context.getters.selectedCommercialSchedule &&
        context.getters.selectedCommercialSchedule.subscription_id
      ) {
        let subscription_id = context.getters.selectedCommercialSchedule.subscription_id
        let organization_id = context.getters.organizationId
        ApiService.get(`/commercial/subscription/show/${subscription_id}`, { organization_id })
          .then(response => {
            let subscription = response.data.subscription
            context.commit('setCommercialSubscription', subscription)
            resolve(response);
          })
          .catch(({response}) => {
            console.log('Commercial Subscription Error');
            reject(response);
          })
      } else {
        reject()
      }
    })
  }
}

const mutations = {
  setCommercialSchedules(state, data) {
    if(Array.isArray(data)) {
      data = data.map(i => {
        let name = i.pricing_plan_name || 'One Time'
        return { ...i, clean_up_frequency: i.service_plan_slug || 'one_time', name }
      })
    }
    state.commercialSchedules = data;
  },
  setLoadingCommercialSchedules(state, status) {
    state.loadingCommercialSchedules = status;
  },
  setSelectedCommercialSchedule(state, schedule) {
    if (!noData.includes(schedule) && !noData.includes(schedule.client_location_id)) {
      state.selectedCommercialScheduleId = schedule.client_location_id;
    } else {
      state.selectedCommercialScheduleId = null
    }
  },

  setNextCommercialClenupDay(state, data) {
    if(state.selectedCommercialScheduleId) {
      let schedules = _.cloneDeep(state.commercialSchedules)
      schedules.forEach(i => {
        if (i.client_location_id === state.selectedCommercialScheduleId) {
          i.nextCleanup = data
        }
      })
      state.commercialSchedules = schedules
    }
  },
  setLoadingNextCommercialClenupDay(state, data) {
    state.loadingNextCommercialClenupDay = data;
  },

  setCommercialSubscription(state, data) {
    let schedules = _.cloneDeep(state.commercialSchedules)
    if(Array.isArray(schedules)) {
      schedules.forEach(i => {
        if (i.subscription_id === data.id) {
          i.subscription = data
          if (i.status !== data.status) {
            i.status = data.status
          }
        }
      })
      state.commercialSchedules = schedules
    }
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
